import * as React from 'react'

import { Box, Colors, Text, ThemeColors } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  onDeleteFile: (index: number) => void
  files: File[]
  renderIcon?: (file: File) => React.ReactNode
  defaultFileItemName?: string
  spaced?: boolean
  errors?: (string | undefined)[]
  background?: Colors | ThemeColors
}

const setDefaultBuilder = (size: number, defaultName: string) => {
  return (index: number) => {
    if (size <= 1) return defaultName

    return `${defaultName} (${index + 1})`
  }
}

const FileList = ({
  files,
  onDeleteFile,
  renderIcon,
  spaced = true,
  defaultFileItemName,
  errors = [],
  background = 'white',
}: Props) => {
  const errorMessage = errors.find((error) => !!error)

  if (!files.length) return null

  const setName = setDefaultBuilder(files.length, defaultFileItemName || i18n.t('common.file'))

  const onDelete = (index: number) => {
    return () => {
      onDeleteFile(index)
    }
  }

  return (
    <Box>
      <Box
        background={background}
        {...{
          paddingY: spaced ? 's32' : undefined,
          borderRadius: errorMessage
            ? {
                all: 'abs008',
              }
            : {},
          border: errorMessage
            ? {
                all: {
                  color: 'radicalRed1000',
                  style: 'solid',
                  width: 's2',
                },
              }
            : {},
        }}
      >
        <BoxList>
          {files.map((file: File, index: number) => (
            <Item
              key={index}
              file={file}
              onDeleteFile={onDelete(index)}
              defaultName={setName(index)}
              renderIcon={renderIcon}
              error={errors[index]}
            />
          ))}
        </BoxList>
      </Box>
      {errorMessage && (
        <Box padding="s2">
          <Text.Normal size="200" color="radicalRed1000">
            {errorMessage}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default observer(FileList)
